import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "space-y-3" }
const _hoisted_2 = { class: "menu-buttons space-y-2" }

import SideMenuButton from "@/components/Menus/SideMenuButton.vue";
import { useMenuStore } from "@/store/menuStore";
import { useAuthStore } from "@/store/authStore";
import { useRouter, useRoute } from "vue-router";
import { computed } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'SideMenu',
  setup(__props) {

const menuStore = useMenuStore();
const authStore = useAuthStore();
const router = useRouter();
const route = useRoute();

const sideMenuOpen = computed(() => menuStore.sideMenuOpen);
const loggedIn = computed(() => authStore.loggedIn);

function isRouteActive(target: string, pattern: string | null = null): boolean {
    if (target === "/" && route.path !== "/") return false;
    if (pattern && new RegExp(pattern).test(route.path)) return true;
    return route.path === target;
}

function openRoute(target: string) {
    router.push(target);
    menuStore.hideSideMenu();
}

const closeMenu = () => {
    menuStore.hideSideMenu();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (sideMenuOpen.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "menu-overlay",
          onClick: closeMenu
        }))
      : _createCommentVNode("", true),
    _createVNode(_Transition, { name: "slide" }, {
      default: _withCtx(() => [
        (sideMenuOpen.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "side-menu fixed top-16 right-0 w-64 h-auto p-4 rounded-l-2xl shadow-xl border",
              style: {"background-color":"var(--background-color)","border-color":"var(--color-primary-dark)"},
              onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
            }, [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  (loggedIn.value)
                    ? (_openBlock(), _createBlock(SideMenuButton, {
                        key: 0,
                        label: "Home",
                        isSelected: isRouteActive('/home', '^/courses'),
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (openRoute('/home'))),
                        class: "menu-button"
                      }, null, 8, ["isSelected"]))
                    : _createCommentVNode("", true),
                  (loggedIn.value)
                    ? (_openBlock(), _createBlock(SideMenuButton, {
                        key: 1,
                        label: "Create Course",
                        isSelected: isRouteActive('/create'),
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (openRoute('/create'))),
                        class: "menu-button"
                      }, null, 8, ["isSelected"]))
                    : _createCommentVNode("", true),
                  (loggedIn.value)
                    ? (_openBlock(), _createBlock(SideMenuButton, {
                        key: 2,
                        label: "Explore",
                        isSelected: isRouteActive('/explore'),
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (openRoute('/explore'))),
                        class: "menu-button"
                      }, null, 8, ["isSelected"]))
                    : _createCommentVNode("", true),
                  (loggedIn.value)
                    ? (_openBlock(), _createBlock(SideMenuButton, {
                        key: 3,
                        label: "Settings",
                        isSelected: isRouteActive('/settings'),
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (openRoute('/settings'))),
                        class: "menu-button"
                      }, null, 8, ["isSelected"]))
                    : _createCommentVNode("", true),
                  _createVNode(SideMenuButton, {
                    label: "Contact",
                    isSelected: isRouteActive('/contact'),
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (openRoute('/contact'))),
                    class: "menu-button"
                  }, null, 8, ["isSelected"])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}
}

})